$(function () {
  $('body').on('change', function (e) {
    if (!e.originalEvent) {
      var $currentTarget = $(e.target);

      if ($currentTarget.data('action')) {
        $currentTarget[0].dispatchEvent(new Event('change'));
      }
    }
  });
});